import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { ClientPortalApiService } from '../../services/client-portal-api.service';
import { AuthStateService } from '@hypenation/auth';
import { Order, OrderStatus, PaginationResponse } from '@hypenation/tickets';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'hypenation-my-orders',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NzTableModule,
    NzTagModule,
    NzButtonModule,
    NzIconModule,
    NzCardModule,
    NzPaginationModule,
    NzSpinModule,
  ],
  templateUrl: './my-orders.component.html',
  styleUrl: './my-orders.component.css',
})
export class MyOrdersComponent implements OnInit {
  loading = false;
  orders: Order[] = [];
  totalItems = 0;
  pageSize = 10;
  pageIndex = 1;
  userEmail: string | null = null;

  private readonly apiService = inject(ClientPortalApiService);
  private readonly authStateService = inject(AuthStateService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.userEmail = this.authStateService.getUserEmail();
    if (this.userEmail) {
      this.loadOrders();
    }
  }

  loadOrders(): void {
    if (!this.userEmail) return;
    this.loading = true;
    this.apiService
      .getOrdersByUser(this.userEmail, this.pageIndex - 1, this.pageSize)
      .subscribe({
        next: (res: HttpResponse<PaginationResponse<Order[]>>) => {
          this.orders = res.body?.content ?? [];
          this.totalItems = res.body?.totalElements ?? 0;
          this.loading = false;
        },
        error: () => (this.loading = false),
      });
  }

  onPageIndexChange(index: number): void {
    this.pageIndex = index;
    this.loadOrders();
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.pageIndex = 1;
    this.loadOrders();
  }

  getStatusColor(status: OrderStatus): string {
    switch (status) {
      case OrderStatus.COMPLETED:
        return 'success';
      case OrderStatus.CANCELLED:
        return 'error';
      case OrderStatus.IN_PROGRESS:
        return 'processing';
      case OrderStatus.RESERVED:
        return 'warning';
      default:
        return 'default';
    }
  }

  formatDate(date: string): string {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  formatCurrency(value: number, currency: string = 'USD'): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    }).format(value);
  }

  goToOrder(orderNumber: string): void {
    this.router.navigate(['/orders', orderNumber]);
  }
}
